/*=========================================================================================
  File Name: moduleCountryActions.js
  Description: Country Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/Country/AddNewCountry", item
        , {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      
      axios.get("api/OpportunityStatus/GetAll"
        , {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then((response) => {
          
          commit('SET_OpportunityStatuses', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put("api/OpportunityStatus/UpdateOpportunityStatus", item
        , {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then((response) => {
          commit('UPDATE_OpportunityStatus', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetItemByID({ commit }, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("api/OpportunityStatus/GetOpportunityStatusByID?opportunityStatusId=" + itemid
        , {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then((response) => {
          commit('UPDATE_OpportunityStatus', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetItemByName({ commit }, name) {
    return new Promise((resolve, reject) => {
      axios.get("api/OpportunityStatus/GetOpportunityStatusByName?name=" + name
        , {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then((response) => {
          commit('GET_OpportunityStatus', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/OpportunityStatus/DeleteOpportunityStatus?opportunityStatusId="+item.ID
        , {headers: { Authorization: 'Bearer ' + localStorage.accessToken,}}
      )
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
